import Login from '../components/LoginEmail'

let routes = {
    path: '/login',
    component: resolve => require(['../components/layout/Login'], resolve),
    children: [
      {
          path: '/login',
          name: 'Login Email',
          component: Login
      },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/loginEmail.js